import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Vission = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full bg-[#f5f7fa] px-6 py-16 flex flex-col items-center justify-center text-center">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="max-w-3xl mb-12"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Mission</h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          Ceyone Foundations creates the environment for economic growth and opportunities by promoting Human Resource Development Standards, skill up gradation & vocational training, innovation, entrepreneurship, competitiveness, modular employability, placements & recruitments, Career development & guidance by motivating and building the Creative skillsets to empower the youth towards service excellence in their personnel life as well as in their career with the support of private and public sectors.
        </p>
        {/* <button className="mt-6 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">Learn More</button> */}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
        className="max-w-3xl"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Vision</h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          Everyone in our nation, regardless of their income, social position and community, will able to access education and training that will benefit them in gaining social justice, employment and advancing their career aspirations hence being the part of proud SKILLED INDIA.
        </p>
        <button onClick={() => navigate('/about')} className="mt-6 px-6 py-2 bg-pink-100 text-pink-800 rounded hover:bg-pink-100 transition">Learn More</button>
      </motion.div>
    </div>
  );
};

export default Vission;
